//ContactUsThankYou.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import MainLayout from "../layouts/MainLayout";

const ContactUsThankYou = () => {
  const location = useLocation();
  const submitstatus = location.state.submitstatus;
  const isThankYouMessage = submitstatus.includes("Thank you");
  const icon = isThankYouMessage ? faCheckCircle : faTimesCircle;
  const iconColor = isThankYouMessage ? "text-green-500" : "text-red-500";
  const messageClass = isThankYouMessage ? "text-green-500" : "text-red-500";


  return (
    <MainLayout>
      <div className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Contact Us</h2>
      </div>
      <div className="flex justify-center items-center h-screen">
        <div className="mb-4">
          <FontAwesomeIcon icon={icon} className={`${iconColor} text-5xl`} />
        </div>
        <div>
          <h2 className={`text-3xl ${messageClass}`}>{submitstatus}</h2>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactUsThankYou;
